export default (state = { treatments: {} }, splitsToGet = []) =>
  Object.keys(state.treatments)
    .filter(treatment => splitsToGet.includes(treatment))
    .reduce((treatments, key) => {
      const selectedTreatments = treatments;
      selectedTreatments[key] = state.treatments[key];
      return selectedTreatments;
    }, {});
